// The six "Before your shift" steps (architecture sprint-14 §8.4), shared by the page and the first-time checklist.
import { SHIFT_SOP_STEPS, sopRuns } from '@/content/shift-sop';

function currentOrigin(): string {
  return typeof window !== 'undefined' ? window.location.origin : 'the Clockit address';
}

export function SopSteps(): JSX.Element {
  const origin = currentOrigin();
  return (
    <ol className="list-decimal space-y-3 pl-5 text-sm text-foreground">
      {SHIFT_SOP_STEPS.map((step, i) => (
        <li key={i}>
          {sopRuns(step, origin).map((r, j) => (r.bold ? <strong key={j} className="font-medium">{r.text}</strong> : <span key={j}>{r.text}</span>))}
        </li>
      ))}
    </ol>
  );
}
